import React, { useState } from "react";
import { Tag } from "primereact/tag";
import { Dropdown } from "primereact/dropdown";

export default function MachineHealth({ dashboardData, loading }) {
  const kioskData = dashboardData?.machineHealthStats?.[0] || {
    healthyCount: 0,
    needAttentionCount: 0,
    kiosksStatus: [],
  };

  const [selectedMachine, setSelectedMachine] = useState("All");

  const machines = kioskData.kiosksStatus.map((kiosk) => ({
    label: kiosk.kioskId,
    value: kiosk.kioskId,
  }));

  return (
    <div className="machine-health-container">
      <div className="filters-container">
        <h3 className="text-xl font-bold mb-0">Machine Health</h3>
        <Dropdown
          value={selectedMachine}
          options={[{ label: "All", value: "All" }, ...machines]}
          onChange={(e) => setSelectedMachine(e.value)}
          placeholder="Select Machine"
          className="dropdown"
        />
      </div>

      <div className="status-counts">
        <div className="status-box">
          <h4 className="healthy-count">{kioskData.healthyCount}</h4>
          <span>Healthy</span>
        </div>
        <div className="status-box">
          <h4 className="need-attention-count">
            {kioskData.needAttentionCount}
          </h4>
          <span>Need Attention</span>
        </div>
      </div>

      <div className="machine-list">
        {kioskData.kiosksStatus.map((machine, index) => (
          <div key={index} className="machine-item">
            <span className="machine-id">{machine.kioskId}</span>
            <Tag
              value={machine.status}
              className={`${
                machine.status === "Healthy"
                  ? "custom-success-tag"
                  : "custom-danger-tag"
              }`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
